import { queryHasPost } from 'hooks/useLike'
import { useMutation } from 'hooks/useMutation'
import { useQueryClient } from 'hooks/useQueryClient'

import { Data } from 'types/query'

type PostCommentParams = {
  postId: string | undefined
}

const updateCommentsInPost = (data: any, postId: string, commentsToAdd: number) => {
  const newPages = data.pages.map((page: any) => {
    const postIndex = page.findIndex((post: any) => post.id === postId)
    if (postIndex > -1) {
      const post = page[postIndex]
      post.commentsCount += commentsToAdd
      if (post.commentsCount < 0) {
        post.commentsCount = 0
      }
      // eslint-disable-next-line no-param-reassign
      page[postIndex] = post
      return page
    }
    return page
  })
  return { ...data, pages: newPages }
}

export const usePostComment = ({ postId }: PostCommentParams) => {
  const queryClient = useQueryClient()

  const optimisticIncrement = async () => {
    queryClient.setQueriesData('posts', (data: Data) => {
      if (postId && data && queryHasPost(data, postId)) {
        return updateCommentsInPost(data, postId, 1)
      }
      return data
    })
    queryClient.setQueryData(['post', postId], (data: Data) => {
      if (data) {
        // eslint-disable-next-line no-param-reassign
        data.commentsCount += 1
      }
      return data
    })
  }

  const addComment = useMutation(() => (postId ? optimisticIncrement() : Promise.reject()), {
    retry: 3,
    onError: (_err, _variables, context: any) => {
      queryClient.setQueriesData('posts', (data: Data) => {
        if (postId && data && queryHasPost(data, postId)) {
          return updateCommentsInPost(data, postId, context?.post?.commentsCount ?? 1)
        }
        return data
      })
    },
  })

  return {
    addComment,
  }
}
